import { createAction } from 'redux-actions';

export interface setRemoteConfigAction extends types.redux.settings.setRemoteConfigAction {}

const setRemoteConfig: any = createAction('SET_REMOTE_CONFIG', (action: setRemoteConfigAction) => action);

const setNewHeaderFooterEnabled: any = createAction(
	'SET_NEW_HEADER_FOOTER_ENABLED',
	(action: setRemoteConfigAction) => action
);

const resetNewHeaderFooterEnabled: any = createAction(
	'RESET_NEW_HEADER_FOOTER_ENABLED',
	(action: { payload: boolean }) => action
);

export { setRemoteConfig, setNewHeaderFooterEnabled, resetNewHeaderFooterEnabled };
